import React from "react";
import useDeviceType from "Utils/useDeviceType";
import QuestionnaireDetailPC from "./components/QuestionnaireDetailPC";
import QuestionnaireDetailMobile from "./components/QuestionnaireDetailMobile";
import { useParams } from "react-router-dom";
import useRequest from "../../../../Utils/useRequest";
import { getPaper, getPaperStatus } from "../service";

export default function QuestionnaireDetail() {
    const { isPC } = useDeviceType();
    const { questionnaireId } = useParams<{ questionnaireId: string }>();
    const [data, { loading }, refreshData] = useRequest(
        () => getPaper(questionnaireId, "1"),
        {},
        [questionnaireId]
    ); //获取试卷
    const [headerData, { loading: headerLoading }, reloadHeadData] = useRequest(
        () => getPaperStatus(questionnaireId),
        {},
        [questionnaireId]
    ); //获取单个问卷

    return (
        <div>
            {isPC && data && headerData && (
                <QuestionnaireDetailPC data={data} headerData={headerData} />
            )}

            {!isPC && data && headerData && (
                <QuestionnaireDetailMobile
                    data={data}
                    headerData={headerData}
                />
            )}
        </div>
    );
}
